import { useEffect, useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/mup/public/appendice`;

const dIT = (iso) => {
  const s = String(iso || "").trim().slice(0, 10);
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  return m ? `${m[3]}/${m[2]}/${m[1]}` : s;
};

export default function MupAppendiceFirma() {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [err, setErr] = useState("");
  const [otp, setOtp] = useState("");
  const [dest, setDest] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [resendIn, setResendIn] = useState(0);
  const [done, setDone] = useState(false);

  const load = useCallback(() => {
    axios.get(`${API}/${token}`).then(({ data }) => { setInfo(data); if (data.signed) setDone(true); })
      .catch((e) => setErr(e.response?.data?.detail || "Link non valido o scaduto"));
  }, [token]);
  useEffect(() => { load(); }, [load]);
  useEffect(() => {
    if (resendIn <= 0) return;
    const t = setInterval(() => setResendIn((s) => (s <= 1 ? 0 : s - 1)), 1000);
    return () => clearInterval(t);
  }, [resendIn]);

  const requestOtp = async () => {
    setBusy(true); setErr("");
    try {
      const { data } = await axios.post(`${API}/${token}/request-otp`);
      setDest(data.destinazione || ""); setSent(true); setResendIn(data.cooldown || 60);
    } catch (e) { setErr(e.response?.data?.detail || "Errore nell'invio del codice"); }
    finally { setBusy(false); }
  };
  const sign = async () => {
    setBusy(true); setErr("");
    try {
      await axios.post(`${API}/${token}/sign`, { otp });
      setDone(true);
    } catch (e) { setErr(e.response?.data?.detail || "Codice non valido"); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-slate-50 py-8 px-4">
      <div className="max-w-lg mx-auto bg-white rounded-2xl border border-slate-200 shadow-sm p-6 sm:p-8">
        <div className="text-xs font-semibold tracking-wide text-blue-700 mb-1">ASSIETICA · MUP</div>
        <h1 className="text-2xl font-bold text-slate-900 mb-4">Firma appendice garanzie</h1>

        {err && <div className="mb-4 rounded-lg bg-red-50 border border-red-200 text-red-700 text-sm p-3" data-testid="apx-err">{err}</div>}

        {done ? (
          <div className="rounded-lg bg-emerald-50 border border-emerald-200 p-4 text-emerald-800" data-testid="apx-done">
            <p className="font-semibold">Firma completata. Grazie!</p>
            <p className="text-sm mt-1">L'appendice delle garanzie non inserite è stata firmata correttamente e allegata al tuo fascicolo.</p>
          </div>
        ) : info ? (
          <>
            <p className="text-sm text-slate-600 mb-3">
              Pratica <b>{info.code}</b>{info.intermediario ? <> · Intermediario: <b>{info.intermediario}</b></> : ""}.
              Confermi che le seguenti garanzie, pur previste nel MUP, <b>non</b> vengono inserite in polizza su tua decisione:
            </p>
            <div className="rounded-lg border border-slate-200 divide-y divide-slate-100 mb-4">
              {(info.garanzie || []).map((g, i) => (
                <div key={i} className="p-2.5 text-sm" data-testid={`apx-g-${i}`}>
                  <div className="font-medium text-slate-900">{g.garanzia}</div>
                  <div className="text-xs text-slate-500">{dIT(g.data)}{g.motivo ? ` · ${g.motivo}` : ""}</div>
                </div>
              ))}
            </div>

            {!sent ? (
              <button data-testid="apx-request-otp" onClick={requestOtp} disabled={busy}
                className="w-full bg-blue-600 text-white rounded-lg py-2.5 font-medium disabled:opacity-50">
                {busy ? "Invio…" : "Ricevi il codice via SMS"}
              </button>
            ) : (
              <div className="space-y-3">
                <p className="text-sm text-slate-600">Ti abbiamo inviato un codice via SMS{dest ? <> al numero <b>{dest}</b></> : ""}. Inseriscilo per firmare.</p>
                <input data-testid="apx-otp-input" value={otp} onChange={(e) => setOtp(e.target.value.replace(/\D/g, ""))}
                  inputMode="numeric" maxLength={6} placeholder="Codice OTP a 6 cifre"
                  className="w-full border border-slate-300 rounded-lg p-2.5 text-center text-lg tracking-widest" />
                <button data-testid="apx-sign-btn" onClick={sign} disabled={busy || otp.length < 6}
                  className="w-full bg-emerald-600 text-white rounded-lg py-2.5 font-medium disabled:opacity-50">
                  {busy ? "Firma in corso…" : "Firma l'appendice"}
                </button>
                <button data-testid="apx-resend" onClick={requestOtp} disabled={resendIn > 0 || busy}
                  className="w-full text-sm text-blue-600 disabled:text-slate-400">
                  {resendIn > 0 ? `Reinvia SMS tra ${resendIn}s` : "Non hai ricevuto il codice? Reinvia SMS"}
                </button>
              </div>
            )}
            <p className="text-xs text-slate-400 mt-4">Firma elettronica semplice con codice OTP monouso inviato via SMS (Reg. UE 910/2014 e CAD).</p>
          </>
        ) : !err ? <p className="text-slate-500">Caricamento…</p> : null}
      </div>
    </div>
  );
}
